import useLocalStorage from "@pathwright/ui/src/components/hooks/useLocalStorage"

function useReviewNotify() {
  return useLocalStorage("reviewNotify", true)
}

export default useReviewNotify
